import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs';
import { SafePlayService } from 'src/app/services/profile/safe-play.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';

@Component({
  selector: 'app-responsible-gaming-dialog',
  templateUrl: './responsible-gaming-dialog.component.html',
  styleUrls: ['./responsible-gaming-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResponsibleGamingDialogComponent {

  private readonly ICONS = {
    INFO: 'info',
    SHIELD_WITH_SEVEN: 'shield-with-seven',
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialogRef: MatDialogRef<ResponsibleGamingDialogComponent>,
    private safePlayService: SafePlayService,
    public licenceService: LicenceService,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private userFullInfoService: UserFullInfoService,
    public detectDeviceService: DetectDeviceService,
  ) {
    this.registerIcons();
  }


  onRemindLater(): void {
    this.handleAction();
  }

  onTakeTest(): void {
    const window = this.document.defaultView;
    if (window) {
      window.open('https://gamblersanonymous.org', '_blank', 'noopener,noreferrer');
    }
    this.handleAction();
  }

  private handleAction(): void {
    this.safePlayService.postRGReminder({}).pipe(take(1)).subscribe({
      next: () => {
        this.userFullInfoService.requestFullInfo(true).pipe(take(1)).subscribe();
        this.dialogRef.close();
      },
      error: () => {
        this.dialogRef.close();
      }
    });
  }
  
  private registerIcons(): void {
    Object.values(this.ICONS).forEach((iconName) => {
        const url = this.licenceService.getKey(iconName);
        this.matIconRegistry.addSvgIcon(
          iconName,
          this.sanitizer.bypassSecurityTrustResourceUrl(url)
        );
      });
  }
}
